import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ service }) => {
  return (
    <div className="card h-100 border-0 shadow-sm hover-shadow transition-all">
      <div className="card-body p-4">
        <div className="d-flex align-items-center mb-3">
          <div className="bg-primary bg-opacity-10 rounded p-3 me-3">
            <i className={`bi ${service.icon} text-primary fs-3`}></i>
          </div>
          <h5 className="card-title mb-0">{service.title}</h5>
        </div>
        <p className="card-text text-muted">{service.description}</p>
        
        {service.features && (
          <ul className="list-unstyled mb-4">
            {service.features.slice(0, 3).map((feature, index) => (
              <li key={index} className="mb-2">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                {feature}
              </li>
            ))}
          </ul>
        )}
        
        {service.subcategories && (
          <div className="mb-4">
            <small className="text-muted d-block mb-2">Available Parts:</small>
            <div className="d-flex flex-wrap gap-2">
              {service.subcategories.slice(0, 4).map((sub, index) => (
                <span key={index} className="badge bg-light text-dark border">
                  {sub}
                </span>
              ))}
            </div>
          </div>
        )}
        
        <Link to="/contact" className="btn btn-outline-primary w-100">
          Enquire Now <i className="bi bi-arrow-right ms-2"></i>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;